import { render, staticRenderFns } from "./erasmus-mc-intranet.vue?vue&type=template&id=58e7de2c&scoped=true&"
import script from "./erasmus-mc-intranet.vue?vue&type=script&lang=js&"
export * from "./erasmus-mc-intranet.vue?vue&type=script&lang=js&"
import style0 from "./erasmus-mc-intranet.vue?vue&type=style&index=0&id=58e7de2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e7de2c",
  null
  
)

/* custom blocks */
import block0 from "./erasmus-mc-intranet.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CaseIntro: require('/app/components/case/intro.vue').default,CaseContent: require('/app/components/case/content.vue').default,CaseVideo: require('/app/components/case/video.vue').default,CaseList: require('/app/components/case/list.vue').default,CaseCta: require('/app/components/case/cta.vue').default,CaseRelated: require('/app/components/case/related.vue').default})
